module.exports = __webpack_public_path__ + "static/media/cq_meno_b.548e4f44.svg";